import BossModel from "@/models/BossModel";
import constants from '@/constants';
import WebsitePackage from "@/models/WebsitePackage/WebsitePackage";

export default class Text extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-package/text';

    /**
     *
     * @type {string}
     */
    static entity = 'websitePackageTexts';

    static fields() {
        return {
            id: this.number(null).nullable(),
            text: this.attr(null),
            website_package_text_type_cid: this.attr(null),
            website_package_id: this.number(null).nullable(),
            ul_list: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            websitePackage: this.belongsTo(WebsitePackage, 'website_package_id'),
        }
    }

    /**
     *
     * @param data
     */
    constructor(data) {
        super(data);
        if(data.website_package_text_type_cid !== undefined
            && data.website_package_text_type_cid !== null
            && data.text !== undefined
            && data.text !== null){
            this[constants.package_text_types.find(type =>  type.id == data.website_package_text_type_cid).value]= data.text;
        }
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     * @constructor
     */
    Update() {
        this.__resolveTypeToText();
        return this.api().update();
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     * @constructor
     */
    Save() {
        this.__resolveTypeToText();
        return this.constructor.api().create(this);
    }

    /**
     *
     * @private
     */
    __resolveTypeToText(){
       this.text =  this[constants.package_text_types.find(type =>  type.id == this.website_package_text_type_cid).value]
    }

}
